import { Box, Button, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { openDialog } from "../../features/dialog";

function GroupButtonBar({selection, search, setSearch}){
    const dispatch = useDispatch();

    return <Box justifyContent="space-between" display="flex" mb={2}>
    <Box flexGrow={0}>
        <TextField
            size="small"
            fullWidth
            placeholder="Search group"
            value={search}
            label="Filter by name"
            onChange={e => setSearch(e.target.value)}
            InputLabelProps={{
                shrink: true
            }}
        />
    </Box>
    <Box display="flex" gap={2} alignItems="center">

        {selection && selection.length > 0 && <Button 
            color="error" 
            variant="outlined"
            onClick={() => {
                dispatch(openDialog({id: "deleteGroup", props: selection.length === 1 ? selection[0] : selection}));
            }}
        >Delete selected</Button> }

        <Button variant="contained" color="secondary" onClick={() => dispatch(openDialog("newGroup"))}>Add Group</Button>
    </Box>
</Box>
}
export default GroupButtonBar;